module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dir_layer_on-5f7a02e58b7e0dd7bc54d19c3bf51e4f.png";